import type { SVGProps } from "react";

const NeoBankLine = ({
  className,
  ...props
}: { className?: string } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="116"
      height="11"
      viewBox="0 0 116 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M114.333 4.33325C114.886 4.33325 115.333 4.78097 115.333 5.33325C115.333 5.88554 114.886 6.33325 114.333 6.33325V5.33325V4.33325ZM5.33337 5.33325V4.33325H114.333V5.33325V6.33325H5.33337V5.33325Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default NeoBankLine;
